/* starterset-lazy-tabs.js
   Het designgrid van de starterset-kiezer staat niet meer in de pagina zelf, maar wordt
   opgehaald zodra iemand de kiezer nodig heeft. Dat scheelde ruim 300 KB en ongeveer 700
   elementen op elke pagina met de kiezer, terwijl de meeste bezoekers hem nooit openen.

   Ophalen gebeurt in twee stappen:
   1. bij het eerste hover, aanraken of focussen van een kiezerknop (dan is het bij de klik
      meestal al binnen);
   2. uiterlijk op het moment dat de kiezer opengaat.

   Bron: templates/product.startersettabs.liquid, dat alleen snippets/starterset-tabs.liquid
   rendert. Toegevoegd 24-9-2026. Backups: Claude AI\theme_backups\*.bak_20260924 */
(function () {
  var plaats = document.querySelector('[data-starterset-tabs]');
  if (!plaats) return;

  var url = plaats.dataset.tabsUrl;
  if (!url) return;

  var bezig = false;
  var klaar = false;

  function zetNeer(html) {
    if (klaar || !plaats.parentNode) return;
    var houder = document.createElement('div');
    houder.innerHTML = html;
    var tabs = houder.querySelectorAll('.tab-images');
    if (!tabs.length) return; // niets bruikbaars terug, plaatshouder laten staan

    // De tabs moeten op precies dezelfde plek in de structuur komen als voorheen,
    // dus als directe buren van de picker-bar en niet in een extra div.
    var ouder = plaats.parentNode;
    tabs.forEach(function (tab) {
      ouder.insertBefore(tab, plaats);
    });
    plaats.remove();
    klaar = true;
    document.dispatchEvent(new CustomEvent('starterset:tabs-geladen'));
  }

  function haal() {
    if (bezig || klaar) return;
    bezig = true;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('status ' + r.status);
        return r.text();
      })
      .then(zetNeer)
      .catch(function (e) {
        bezig = false; // volgende poging mag opnieuw
        console.warn('[starterset] designs ophalen mislukt:', e);
      });
  }

  var KNOPPEN = '.colorModel-wrapper.main .chooseColor, .colorModel-wrapper.main a.button, .add-in-overlay';

  // 1. Vooruit ophalen zodra iemand richting de knop beweegt.
  ['pointerenter', 'touchstart', 'focusin'].forEach(function (soort) {
    document.addEventListener(
      soort,
      function (e) {
        if (klaar || bezig) return;
        if (e.target.closest && e.target.closest(KNOPPEN)) haal();
      },
      { passive: true, capture: true }
    );
  });

  // 2. En hoe dan ook bij de klik zelf, ook als stap 1 niet is gebeurd.
  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest && e.target.closest(KNOPPEN)) haal();
    },
    { capture: true }
  );

  // Vangnet: gaat de kiezer op een andere manier open, dan alsnog ophalen.
  var overlay = document.querySelector('#nailsoverlay');
  if (overlay && window.MutationObserver) {
    new MutationObserver(function () {
      if (!overlay.classList.contains('hidden')) haal();
    }).observe(overlay, { attributes: true, attributeFilter: ['class'] });
  }
})();
